import { BigFiveTypes, BIG_FIVE_VALUES } from '@dashboard/lib/types'

interface BigFiveQuestion {
  text: string
  bigFiveIndex: number
  isInverse: boolean
}

export function assessmentQuestions(): BigFiveQuestion[] {
  return [
    {
      text: 'Am the life of the party.',
      bigFiveIndex: 0,
      isInverse: false,
    },
    {
      text: 'Feel little concern for others.',
      bigFiveIndex: 1,
      isInverse: true,
    },
    {
      text: 'Am always prepared.',
      bigFiveIndex: 2,
      isInverse: false,
    },
    {
      text: 'Get stressed out easily.',
      bigFiveIndex: 3,
      isInverse: true,
    },
    {
      text: 'Have a rich vocabulary.',
      bigFiveIndex: 4,
      isInverse: false,
    },
    {
      text: "Don't talk a lot.",
      bigFiveIndex: 0,
      isInverse: true,
    },
    {
      text: 'Am interested in people.',
      bigFiveIndex: 1,
      isInverse: false,
    },
    {
      text: 'Leave my belongings around.',
      bigFiveIndex: 2,
      isInverse: true,
    },
    {
      text: 'Am relaxed most of the time.',
      bigFiveIndex: 3,
      isInverse: false,
    },
    {
      text: 'Have difficulty understanding abstract ideas.',
      bigFiveIndex: 4,
      isInverse: true,
    },
    {
      text: 'Feel comfortable around people.',
      bigFiveIndex: 0,
      isInverse: false,
    },
    {
      text: 'Insult people.',
      bigFiveIndex: 1,
      isInverse: true,
    },
    {
      text: 'Pay attention to details.',
      bigFiveIndex: 2,
      isInverse: false,
    },
    {
      text: 'Worry about things.',
      bigFiveIndex: 3,
      isInverse: true,
    },
    {
      text: 'Have a vivid imagination.',
      bigFiveIndex: 4,
      isInverse: false,
    },
    {
      text: 'Keep in the background.',
      bigFiveIndex: 0,
      isInverse: true,
    },
    {
      text: "Sympathize with others' feelings.",
      bigFiveIndex: 1,
      isInverse: false,
    },
    {
      text: 'Make a mess of things.',
      bigFiveIndex: 2,
      isInverse: true,
    },
    {
      text: 'Seldom feel blue.',
      bigFiveIndex: 3,
      isInverse: false,
    },
    {
      text: 'Am not interested in abstract ideas.',
      bigFiveIndex: 4,
      isInverse: true,
    },
    {
      text: 'Start conversations.',
      bigFiveIndex: 0,
      isInverse: false,
    },
    {
      text: "Am not interested in other people's problems.",
      bigFiveIndex: 1,
      isInverse: true,
    },
    {
      text: 'Get chores done right away.',
      bigFiveIndex: 2,
      isInverse: false,
    },
    {
      text: 'Am easily disturbed.',
      bigFiveIndex: 3,
      isInverse: true,
    },
    {
      text: 'Have excellent ideas.',
      bigFiveIndex: 4,
      isInverse: false,
    },
    {
      text: 'Have little to say.',
      bigFiveIndex: 0,
      isInverse: true,
    },
    {
      text: 'Have a soft heart.',
      bigFiveIndex: 1,
      isInverse: false,
    },
    {
      text: 'Often forget to put things back in their proper place.',
      bigFiveIndex: 2,
      isInverse: true,
    },
    {
      text: 'Get upset easily.',
      bigFiveIndex: 3,
      isInverse: true,
    },
    {
      text: 'Do not have a good imagination.',
      bigFiveIndex: 4,
      isInverse: true,
    },
    {
      text: 'Talk to a lot of different people at parties.',
      bigFiveIndex: 0,
      isInverse: false,
    },
    {
      text: 'Am not really interested in others.',
      bigFiveIndex: 1,
      isInverse: true,
    },
    {
      text: 'Like order.',
      bigFiveIndex: 2,
      isInverse: false,
    },
    {
      text: 'Change my mood a lot.',
      bigFiveIndex: 3,
      isInverse: true,
    },
    {
      text: 'Am quick to understand things.',
      bigFiveIndex: 4,
      isInverse: false,
    },
    {
      text: "Don't like to draw attention to myself.",
      bigFiveIndex: 0,
      isInverse: true,
    },
    {
      text: 'Take time out for others.',
      bigFiveIndex: 1,
      isInverse: false,
    },
    {
      text: 'Shirk my duties.',
      bigFiveIndex: 2,
      isInverse: true,
    },
    {
      text: 'Have frequent mood swings.',
      bigFiveIndex: 3,
      isInverse: true,
    },
    {
      text: 'Use difficult words.',
      bigFiveIndex: 4,
      isInverse: false,
    },
    {
      text: "Don't mind being the center of attention.",
      bigFiveIndex: 0,
      isInverse: false,
    },
    {
      text: "Feel others' emotions.",
      bigFiveIndex: 1,
      isInverse: false,
    },
    {
      text: 'Follow a schedule.',
      bigFiveIndex: 2,
      isInverse: false,
    },
    {
      text: 'Get irritated easily.',
      bigFiveIndex: 3,
      isInverse: true,
    },
    {
      text: 'Spend time reflecting on things.',
      bigFiveIndex: 4,
      isInverse: false,
    },
    {
      text: 'Am quiet around strangers.',
      bigFiveIndex: 0,
      isInverse: true,
    },
    {
      text: 'Make people feel at ease.',
      bigFiveIndex: 1,
      isInverse: false,
    },
    {
      text: 'Am exacting in my work.',
      bigFiveIndex: 2,
      isInverse: false,
    },
    {
      text: 'Often feel blue.',
      bigFiveIndex: 3,
      isInverse: true,
    },
    {
      text: 'Am full of ideas.',
      bigFiveIndex: 4,
      isInverse: false,
    },
  ]
}

export function getDescription(bigFive: BigFiveTypes) {
  switch (bigFive) {
    case 'Extraversion':
      return 'Extroversion is a measure of how outgoing, talkative, and people-oriented someone is.'
    case 'Agreeableness':
      return 'Agreeableness measures how easily a person connects with others.'
    case 'Conscientiousness':
      return 'Conscientiousness measures the thoughtfulness and organization of a person.'
    case 'Emotional Stability':
      return 'Emotional Stability is a measure of how calm and stable a person is during stress.'
    case 'Openness':
      return 'Openness is the measure of how open to experience, open-minded, and imaginative an individual is.'
  }
}

function amountFromAnswer(question: BigFiveQuestion, value: number) {
  return question.isInverse ? 6 - value : value
}

export function getBigFiveScores(
  answers: number[],
): Record<BigFiveTypes, number> {
  const sums: Record<BigFiveTypes, number> = {
    'Emotional Stability': 0,
    Agreeableness: 0,
    Conscientiousness: 0,
    Extraversion: 0,
    Openness: 0,
  }
  const questions = assessmentQuestions()

  answers.forEach((answer, index) => {
    const question = questions[index]
    const sum = sums[BIG_FIVE_VALUES[question.bigFiveIndex]] || 0

    sums[BIG_FIVE_VALUES[question.bigFiveIndex]] =
      sum + amountFromAnswer(question, answer)
  })

  return sums
}

export function getRawScorePercentile(trait: BigFiveTypes, rawScore: number) {
  const staticData = {
    'Emotional Stability': {
      mean: 29.55705670116668,
      stdev: 8.34619640872165,
    },
    Agreeableness: {
      mean: 38.83816596876564,
      stdev: 7.052341796726304,
    },
    Conscientiousness: {
      mean: 34.239235205814964,
      stdev: 7.60250676208783,
    },
    Extraversion: {
      mean: 30.549747182134205,
      stdev: 9.455200148050746,
    },
    Openness: {
      mean: 39.10089012956916,
      stdev: 6.1310336838831025,
    },
  }
  const { mean, stdev } = staticData[trait]
  const zScore = (rawScore - mean) / stdev

  return zScoreToPercentage(zScore)
}

// This is statistical math that is above my head but works.
function zScoreToPercentage(zScore: number): number {
  if (zScore < -6.5) return 0
  if (zScore > 6.5) return 1

  let factk = 1
  let sum = 0
  let term = 1
  let k = 0
  const loop_stop = Math.exp(-23)

  while (Math.abs(term) > loop_stop) {
    term =
      (((0.3989422804 * Math.pow(-1, k) * Math.pow(zScore, k)) /
        (2 * k + 1) /
        Math.pow(2, k)) *
        Math.pow(zScore, k + 1)) /
      factk
    sum += term
    k += 1
    factk *= k
  }

  sum += 0.5

  return sum
}
